// extracted by mini-css-extract-plugin
module.exports = {"newsletter__checkbox":"Newsletter_newsletter__checkbox__2jYjl","newsletter__field":"Newsletter_newsletter__field__3U0qN"};